import { createContext, ReactNode, useMemo, useState } from 'react';

type UnSavedChangesProviderType = {
  children: ReactNode;
};
export type UnSavedChangesContextType = {
  hasUnsavedChanges: boolean;
  handleUpdateUnsavedChanges: (value: boolean) => void;
};

const UnSavedChangesContext = createContext<UnSavedChangesContextType>({
  hasUnsavedChanges: false,
  handleUpdateUnsavedChanges: () => {},
});

const UnSavedChangesProvider = ({ children }: UnSavedChangesProviderType) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState<boolean>(false);
  const handleUpdateUnsavedChanges = (value: boolean) => {
    setHasUnsavedChanges(value);
  };

  const contextValue = useMemo(
    () => ({
      hasUnsavedChanges,
      handleUpdateUnsavedChanges,
    }),
    [hasUnsavedChanges, handleUpdateUnsavedChanges],
  );

  return (
    <UnSavedChangesContext.Provider value={contextValue}>
      {children}
    </UnSavedChangesContext.Provider>
  );
};

export { UnSavedChangesContext, UnSavedChangesProvider };
